<template>
    <transition name="modal">  
        <!-- The Modal -->
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content rounded-8">

                        <!-- Modal Header -->
                        <div class="modal-header bg-utel-v2-secondary text-primary">
                            <h4 class="modal-title"><strong>{{ info.title }}</strong></h4>
                            <button type="button" class="close" data-dismiss="modal">×</button>
                        </div>
                        
                        <!-- Modal body -->
                        <div class="modal-body">
                            <p>{{ info.content }}</p>
                        </div>
                        
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn text-white bg-utel rounded-8" id="cancel-button-routes" @click="close" aria-label="Close modal" data-dismiss="modal">
                                Aceptar
                            </button>                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>        
    </transition>
</template>

<script>
export default {
    props: ['info'],
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        close() {
            this.$emit('close');
        }
    },
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  /*display: table;*/
  transition: opacity .3s ease;
}

.modal-wrapper {
  /*display: table-cell;*/
  vertical-align: middle;
}
</style>
